



























import Vue from "vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { AddOrganizationCommand } from "@/model/communication/organizations/AddOrganizationCommand";
import { Organization } from "@/model/data/organizations/Organization";

export default Vue.extend({
    data() {
        return {
            creatingOrganization: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            organizationName: null,
            availableProfiles: [],
            organizationProfile: null,
            createdOrganization: null,
        };
    },
    props: {
        folderToConvert: {
            type: Object,
        },
    },
    computed: {
        saveable() {
            return this.creatingOrganization || this.organizationName == null || this.organizationName.trim().length == 0 ? false : true;
        },
    },
    watch: {
        folderToConvert(value) {
            this.reset();
        },
    },
    methods: {
        async addOrganization() {
            try {
                if (!this.creatingOrganization) {
                    this.creatingOrganization = true;

                    var organization = new Organization();
                    organization.name = this.organizationName;
                    organization.folderId = this.folderToConvert.id;

                    var res = await new AddOrganizationCommand(organization).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                        this.createdOrganization = res.organizations[0];
                        this.showSuccessAlert = true;
                    } else this.showErrorAlert = true;

                    this.creatingOrganization = false;
                }
            } catch (error) {
                console.log("Something went wrong in addOrganization()", error);
                this.creatingOrganization = false;
            }
        },

        reset() {
            this.creatingOrganization = false;
            this.showSuccessAlert = false;
            this.showErrorAlert = false;
            this.organizationName = this.folderToConvert.name;
            this.createdOrganization = null;
        },
    },
    mounted() {
        this.reset();
    },
});
